import { useSearch } from "@tanstack/react-router";
import { z } from "zod";

import {
  INVITE_TYPE,
  INVITE_TYPE_CSV,
  INVITE_TYPE_EMAIL,
} from "./Tabs/DetailsTab/components/constants";
import { FROM_GETTING_STARTED } from "./useNavigateAfterInviteFlow";

const inviteTypeSchema = z
  .enum([INVITE_TYPE_EMAIL, INVITE_TYPE_CSV])
  .catch(INVITE_TYPE_EMAIL);

const fromSchema = z.preprocess((value: unknown) => {
  if (typeof value !== "string") {
    return undefined;
  }
  if (
    value === FROM_GETTING_STARTED ||
    (value.startsWith("/") && !value.startsWith("//"))
  ) {
    return value;
  }
  return undefined;
}, z.string().optional());

// Accepts a single id (`?newsletter_list_ids=12`) or a list (`?newsletter_list_ids=[12,13]`)
const newsletterListIdsSchema = z
  .preprocess(
    (value: unknown) => [value].flat(),
    z.array(z.coerce.number().int().positive()),
  )
  .optional()
  .catch(undefined);

export const queryParamsSchema = z.object({
  [INVITE_TYPE]: inviteTypeSchema,
  from: fromSchema,
  prefill_token: z.string().optional().catch(undefined),
  newsletter_list_ids: newsletterListIdsSchema,
});

export const importContactsQueryParamsSchema = queryParamsSchema.pick({
  from: true,
  newsletter_list_ids: true,
});

export type QueryParams = z.infer<typeof queryParamsSchema>;

export const validateInviteMembersQueryParams = (
  search: Record<string, unknown>,
): QueryParams => queryParamsSchema.parse(search);

export const useInviteMembersQueryParams = (): QueryParams => {
  const search = useSearch({ strict: false });

  return validateInviteMembersQueryParams(search as Record<string, unknown>);
};
